module.exports = __webpack_public_path__ + "static/media/talentx-manager@2x.c449ff84.png";